// check if an app state variable is fully loaded (sometimes loading is false, but the object is an empty array)
const isLoaded = (object) => object && (!Array.isArray(object) || object.length);

// eslint-disable-next-line import/prefer-default-export
export { isLoaded };


// WEBPACK FOOTER //
// ./src/utils/redux-utils.js